export default function Footer() {
    return (
        <footer className="app-footer">
            <span className="footer-copy">© {new Date().getFullYear()} checklists.guru</span>
            <a className="footer-contact" href="mailto:info@checklists.guru">info@checklists.guru</a>
        </footer>
    );
}
